export interface TextPart {
  text: string;
  match: boolean;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * `text` cut where it holds `query`, case-insensitively, so the matches can be
 * set apart — "BTC" in "Will BTC hit…", "btc" in "satoshi_btc". No query, or
 * no match, is one plain part.
 */
export function splitByMatch(text: string, query: string): TextPart[] {
  const needle = query.trim();
  if (!needle) return [{ text, match: false }];
  return text
    .split(new RegExp(`(${escapeRegExp(needle)})`, 'gi'))
    .filter(Boolean)
    .map((part) => ({ text: part, match: part.toLowerCase() === needle.toLowerCase() }));
}
